module.exports = __webpack_public_path__ + "static/media/confidence-ranking.8ecfde5e.gif";


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/confidence-ranking.gif
// module id = 114
// module chunks = 0